import { KYMW6501Model } from '../kymw6501.model';
import { TimeSaleDataModel } from '../vo/time-sale-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タイムセールマスタ一覧の取得
 *
 * @export API通信成功時の処理
 * @class GetCwsTimeSaleInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsTimeSaleInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6501Model;
  private successFunc: Function;
  private vo: TimeSaleDataModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsTimeSaleInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        CategoryCode: this.vo.CategoryCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6501Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCwsTimeSaleInfo
   */
  execute(model: KYMW6501Model, vo: TimeSaleDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsTimeSaleInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsTimeSaleInfo
   */
  success(data: any) {
    this.model.setInitData(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
